import CategoryDropdown from "./CategoryDropdown";

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Clean%20minimalist%20product%20photography%20flat%20lay%20composition%20featuring%20sneakers%20hoodie%20accessories%20and%20fashion%20items%20arranged%20in%20organized%20grid%20pattern%20on%20light%20cream%20linen%20surface%2C%20soft%20natural%20window%20lighting%2C%20warm%20beige%20and%20oatmeal%20tones%2C%20editorial%20fashion%20catalog%20aesthetic%2C%20structured%20spreadsheet-like%20layout%2C%20subtle%20shadows%2C%20professional%20e-commerce%20product%20display%2C%20no%20text%20no%20logos&width=1600&height=900&seq=hero-main-v2&orientation=landscape"
          alt="Sugargoo Spreadsheet fashion products background"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/50"></div>
      </div>

      <div className="relative z-10 w-full px-6 md:px-10">
        <div className="max-w-4xl mx-auto text-center flex flex-col items-center gap-6">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20">
            <i className="ri-sparkling-line text-white/90 text-sm"></i>
            <span className="text-white/90 text-xs font-medium whitespace-nowrap">Updated Resources · Beginner Friendly · Independent Research Platform · Free Shopping Guides</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl text-white leading-tight max-w-3xl">
            Sugargoo Spreadsheet &mdash; The Ultimate Database For Smart Shopping
          </h1>

          <p className="text-white/80 text-base md:text-lg max-w-2xl leading-relaxed">
            Discover thousands of organized Sugargoo finds, product spreadsheets, shopping guides, warehouse tips, shipping cost analysis, and expert reviews in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 mt-2">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-primary-500 text-white font-semibold text-sm hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              Sugargoo Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 rounded-full bg-white/15 backdrop-blur-sm text-white font-semibold text-sm border border-white/30 hover:bg-white/25 transition-colors cursor-pointer whitespace-nowrap"
            >
              Buy It Now
            </a>
          </div>

          <div className="mt-6 w-full max-w-md">
            <p className="text-white/70 text-xs mb-3 font-medium">Or browse by category:</p>
            <CategoryDropdown />
          </div>
        </div>
      </div>
    </section>
  );
}